import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import useResponsive from "../../Hooks/useResponsive";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import GlobalDialog from "../../components/mui/Dialogue/GlobalDialog";
import {
  Alert,
  AlertTitle,
  Autocomplete,
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputLabel,
  MenuItem,
  Select,
  Skeleton,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import DatePickerCustom from "../../components/DatePicker/DatePickerCustom";
import { AddButton, SubmitButton } from "../../components/mui/Buttons/Buttons";
import {
  addFood,
  getAllUsers,
  getEveningFoodList,
  getFoodList,
  getFoodSlots,
  getFoodStatus,
  techAddFood,
} from "../../redux/features/foodSlice";
import { getUsersUnderDepartment } from "../../redux/features/permissionSlice";
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import GlobalAutoCompleteMultiSelect from "../../components/mui/GlobalAutoCompleteMultiSelect";
import { useLocation, useNavigate } from "react-router-dom";

const FoodMark = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const [selectedFoodSlot, setSelectedFoodSlot] = useState(1); // 1 for Lunch, 2 for Evening
  const [selectedTimeSlot, setSelectedTimeSlot] = useState("");
  const [selectedOfficeSlot, setSelectedOfficeSlot] = useState(6);
  const [timingSlots, setTimingSlots] = useState([]);
  const [isNonVegDay, setIsNonVegDay] = useState(false);
  const [vegReq, setVegReq] = useState(false);
  const [selectedDate, setSelectedDate] = useState(
    dayjs().add(1, "day").format("YYYY-MM-DD")
  );
  const dispatch = useDispatch();
  const { loading, lunchslots, eveningSlots, foodStatus, foodList } =
    useSelector((store) => store.food);
  const { usersunderdpt } = useSelector((store) => store.permission);
  const [direction, setDirection] = useState("row");
  const mdDown = useResponsive("down", "md");
  const navigate = useNavigate();
  const location = useLocation();
  const foodSlots = [
    { id: 1, value: "Lunch" },
    // { id: 2, value: "Evening" },
  ];
  const offices = [
    { id: 6, value: "Pathanapuram" },
    { id: 7, value: "Office 2" },
  ];

  useEffect(() => {
    if (mdDown) {
      setDirection("column");
    } else {
      setDirection("row");
    }
  }, [mdDown]);

  useEffect(() => {
    if (open) {
      dispatch(getUsersUnderDepartment(5));
      dispatch(getFoodSlots());
      dispatch(getFoodList({ date: selectedDate }));
    }
  }, [open]);

  useEffect(() => {
    if (open) {
      setTimingSlots(lunchslots);
    }
  }, [open, lunchslots]);

  const handleSlotChange = (e) => {
    if (e.target.name == "foodSolt") {
      setSelectedFoodSlot(e.target.value);
    } else if (e.target.name == "timeSlots") {
      setSelectedTimeSlot(e.target.value);
    } else if (e.target.name == "offices") {
      setSelectedOfficeSlot(e.target.value);
    } else if (e.target.name == "vegRequired") {
      setVegReq(e.target.checked);
    }
  };

  // useEffect(() => {
  //   dispatch(getFoodStatus(selectedDate));
  //   dispatch(getFoodSlots());
  // }, [open, selectedDate]);

  // useEffect(() => {
  //   if (selectedFoodSlot === 1) {
  //     setTimingSlots(lunchslots);
  //     // setSelectedTimeSlot(lunchslots[0]?.food_slot_id);
  //     dispatch(
  //       getFoodList({
  //         date: dayjs().add(1, "day").format("YYYY-MM-DD"),
  //       })
  //     );
  //   } else if (selectedFoodSlot === 2) {
  //     setTimingSlots(eveningSlots);
  //     // setSelectedTimeSlot(eveningSlots[0]?.food_slot_id);
  //     dispatch(
  //       getEveningFoodList({
  //         date: dayjs().format("YYYY-MM-DD"),
  //       })
  //     );
  //   }
  // }, [selectedFoodSlot]);

  // useEffect(() => {
  //   if (foodStatus.length > 0) {
  //     const isComingDayFoodAlreadyDefined =
  //       foodStatus[0].day_food_status_date == selectedDate;
  //     if (isComingDayFoodAlreadyDefined) {
  //       const isNon = foodStatus[0].day_food_meal_status == 2;
  //       setIsNonVegDay(isNon);
  //     }
  //   } else if (dayjs(selectedDate).get("day") === 5) {
  //     setIsNonVegDay(true);
  //   } else {
  //     setIsNonVegDay(false);
  //   }
  // }, [foodStatus]);

  const handleCancel = () => {
    setOpen(false);
    formik.resetForm();
    setSelectedTimeSlot("");
  };

  const initialValues = {
    users: [],
  };

  const schema = Yup.object({
    users: Yup.array().min(1, "At least one User is required"),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: schema,
    onSubmit: (values) => {
      const data = {
        userIds: values.users,
        foodDate: selectedDate,
        foodOffice: selectedOfficeSlot,
        foodSlotId: selectedTimeSlot,
        // foodCategory: vegReq ? 2 : 1,
        foodCategory: 1,
      };
      dispatch(techAddFood(data)).then((res) => {
        if (res.payload.status == "failed" || res.payload.status === "error") {
          enqueueSnackbar(`${res.payload.message}`, { variant: "error" });
        } else {
          enqueueSnackbar(` ${res.payload.message}`, {
            variant: "success",
          });
          setOpen(false);
          if (location.pathname === "/employeeservices/food") {
            window.location.reload();
          } else {
            navigate("/employeeservices/food");
          }
        }
      });
    },
  });
  const [availableSeat, setAvailableSeat] = useState("");

  useEffect(() => {
    if (selectedTimeSlot) {
      const slotObject = lunchslots.find(
        (s) => s.food_slot_id == selectedTimeSlot
      );
      const seatCapacity = slotObject?.food_slot_capacity || 100;
      const count =
        foodList.filter((data) => data.food_slot_id == selectedTimeSlot)
          ?.length ?? 0;
      const seatsAvailable = Math.max(0, seatCapacity - count);
      setAvailableSeat(seatsAvailable);
    }
  }, [selectedTimeSlot]);

  return (
    <GlobalDialog
      title={"Add Lunch for Multiple Users"}
      open={open}
      setOpen={setOpen}
      fullWidth
      // maxWidth={"md"}
      closeButton={true}
      closeCondition={handleCancel}
      popupButton={
        <AddButton size="small" action={() => setOpen(true)}>
          {" "}
          Apply To Multiple
        </AddButton>
      }
      content={
        <>
          {loading ? (
            <Box>
              <Stack gap={2}>
                <Skeleton variant="rectangular" width={"100%"} height={60} />
                <Skeleton variant="rectangular" width={"100%"} height={60} />
                <Skeleton variant="rectangular" width={"100%"} height={60} />
                <Skeleton variant="square" width={80} height={40} />
              </Stack>
            </Box>
          ) : (
            <>
              <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                  <Stack gap={2}>
                    <Box sx={{ flex: 1 }}>
                      <GlobalAutoCompleteMultiSelect
                        options={{
                          formik: formik,
                          label: "Users",
                          name: "users",
                          data: usersunderdpt,
                          keys: {
                            id: "userID",
                            value: "name",
                          },
                          sx: {
                            width: "100%",
                          },
                        }}
                      />
                    </Box>

                    <Stack direction={direction} gap={2} sx={{ width: "100%" }}>
                      <Box sx={{ flex: 1 }}>
                        <DatePickerCustom
                          value={dayjs(selectedDate)}
                          setValue={(date) =>
                            setSelectedDate(date.format("YYYY-MM-DD"))
                          }
                          viewDetails={["year", "month", "day"]}
                          fullWidth
                          disabled={false}
                        />
                      </Box>
                      <Box sx={{ flex: 1 }}>
                        <FormControl fullWidth>
                          <InputLabel>Food Slots </InputLabel>
                          <Select
                            disabled
                            fullWidth
                            name="foodSolt"
                            label="Food Slots"
                            value={selectedFoodSlot}
                            onChange={handleSlotChange}
                          >
                            {foodSlots?.map((item) => (
                              <MenuItem key={item.id} value={item.id}>
                                {item.value}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Box>
                    </Stack>

                    <Stack direction={direction} gap={2} sx={{ width: "100%" }}>
                      <Box sx={{ flex: 1 }}>
                        <FormControl fullWidth>
                          <InputLabel>Time Slots </InputLabel>
                          <Select
                            name="timeSlots"
                            label="Time Slots"
                            value={selectedTimeSlot}
                            onChange={handleSlotChange}
                          >
                            {timingSlots?.map((item) => (
                              <MenuItem
                                key={item.food_slot_id}
                                value={item.food_slot_id}
                              >
                                {item.food_slot_name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Box>
                      <Box sx={{ flex: 1 }}>
                        <FormControl fullWidth>
                          <InputLabel>Office</InputLabel>
                          <Select
                            name="offices"
                            label="offices"
                            value={selectedOfficeSlot}
                            onChange={handleSlotChange}
                            disabled
                          >
                            {offices?.map((item) => (
                              <MenuItem key={item.id} value={item.id}>
                                {item.value}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Box>
                    </Stack>

                    <Box sx={{ mt: -1, ml: -1 }}>
                      {selectedFoodSlot == 1 && !loading && isNonVegDay && (
                        <FormGroup row>
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={handleSlotChange}
                                name="vegRequired"
                                checked={vegReq}
                                disabled
                              />
                            }
                            label="Veg Required"
                            labelPlacement="start"
                          />
                        </FormGroup>
                      )}
                    </Box>
                    {selectedTimeSlot && (
                      <Alert
                        severity={
                          availableSeat <= 0
                            ? "error"
                            : availableSeat < formik.values.users.length
                            ? "error"
                            : "info"
                        }
                      >
                        <AlertTitle>Capacity Details</AlertTitle>
                        <Typography>
                          There are <strong>{availableSeat}</strong> seats
                          available.
                        </Typography>
                        <Typography>
                          Required seats are{" "}
                          <strong>{formik.values.users.length}</strong>.
                        </Typography>
                      </Alert>
                    )}

                    <Box>
                      <SubmitButton
                        disabled={
                          loading ||
                          availableSeat <= 0 ||
                          availableSeat < formik.values.users.length
                        }
                        type="submit"
                      >
                        Add Food
                      </SubmitButton>
                    </Box>
                  </Stack>
                </Form>
              </FormikProvider>
            </>
          )}
        </>
      }
    />
  );
};

export default FoodMark;
